import styled from 'styled-components';

import { gridDisplay, gridTemplateRows, gridTemplateColumns } from 'styleUtils/grid';

export const PersonWrapper = styled.div`
    ${gridDisplay()}
    ${gridTemplateColumns('50px 1fr')}
    ${gridTemplateRows('auto')}
    align-content: center;
    margin-bottom: 20px;
`;
